import { IconProps } from "./Icons";

export const IconBoard = ({
  width = 72,
  height = 72,
  isHovered = false,
  color = "white",
}: IconProps) => {
  // Icono Hover
  if (isHovered) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 72 72"
        fill="none"
      >
        <path
          d="M47.25 42.75C47.25 43.3467 47.0129 43.919 46.591 44.3409C46.169 44.7629 45.5967 45 45 45H27C26.4033 45 25.831 44.7629 25.409 44.3409C24.9871 43.919 24.75 43.3467 24.75 42.75C24.75 42.1532 24.9871 41.5809 25.409 41.159C25.831 40.737 26.4033 40.5 27 40.5H45C45.5967 40.5 46.169 40.737 46.591 41.159C47.0129 41.5809 47.25 42.1532 47.25 42.75ZM45 31.5H27C26.4033 31.5 25.831 31.737 25.409 32.159C24.9871 32.5809 24.75 33.1532 24.75 33.75C24.75 34.3467 24.9871 34.919 25.409 35.3409C25.831 35.7629 26.4033 36 27 36H45C45.5967 36 46.169 35.7629 46.591 35.3409C47.0129 34.919 47.25 34.3467 47.25 33.75C47.25 33.1532 47.0129 32.5809 46.591 32.159C46.169 31.737 45.5967 31.5 45 31.5ZM60.75 13.5V60.75C60.75 61.9434 60.2759 63.088 59.432 63.9319C58.5881 64.7758 57.4435 65.25 56.25 65.25H15.75C14.5565 65.25 13.4119 64.7758 12.568 63.9319C11.7241 63.088 11.25 61.9434 11.25 60.75V13.5C11.25 12.3065 11.7241 11.1619 12.568 10.318C13.4119 9.47406 14.5565 8.99996 15.75 8.99996H25.9481C27.2124 7.5845 28.7613 6.45199 30.4935 5.67659C32.2257 4.90119 34.1022 4.50037 36 4.50037C37.8978 4.50037 39.7743 4.90119 41.5065 5.67659C43.2387 6.45199 44.7876 7.5845 46.0519 8.99996H56.25C57.4435 8.99996 58.5881 9.47406 59.432 10.318C60.2759 11.1619 60.75 12.3065 60.75 13.5ZM27 18H45C45 15.613 44.0518 13.3238 42.364 11.636C40.6761 9.94817 38.3869 8.99996 36 8.99996C33.613 8.99996 31.3239 9.94817 29.636 11.636C27.9482 13.3238 27 15.613 27 18ZM56.25 13.5H48.7266C49.2384 14.9451 49.4999 16.4669 49.5 18V20.25C49.5 20.8467 49.2629 21.419 48.841 21.8409C48.419 22.2629 47.8467 22.5 47.25 22.5H24.75C24.1533 22.5 23.581 22.2629 23.159 21.8409C22.7371 21.419 22.5 20.8467 22.5 20.25V18C22.5001 16.4669 22.7616 14.9451 23.2734 13.5H15.75V60.75H56.25V13.5Z"
          fill={color}
        />
      </svg>
    );
  }

  // Icono normal
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 72 72"
      fill="none"
    >
      <path
        d="M56.25 8.99996H46.0519C44.7876 7.5845 43.2387 6.45199 41.5065 5.67659C39.7743 4.90119 37.8978 4.50037 36 4.50037C34.1022 4.50037 32.2257 4.90119 30.4935 5.67659C28.7613 6.45199 27.2124 7.5845 25.9481 8.99996H15.75C14.5565 8.99996 13.4119 9.47406 12.568 10.318C11.7241 11.1619 11.25 12.3065 11.25 13.5V60.75C11.25 61.9434 11.7241 63.088 12.568 63.9319C13.4119 64.7758 14.5565 65.25 15.75 65.25H56.25C57.4435 65.25 58.5881 64.7758 59.432 63.9319C60.2759 63.088 60.75 61.9434 60.75 60.75V13.5C60.75 12.3065 60.2759 11.1619 59.432 10.318C58.5881 9.47406 57.4435 8.99996 56.25 8.99996ZM36 8.99996C38.3869 8.99996 40.6761 9.94817 42.364 11.636C44.0518 13.3238 45 15.613 45 18H27C27 15.613 27.9482 13.3238 29.636 11.636C31.3239 9.94817 33.613 8.99996 36 8.99996ZM56.25 60.75H15.75V13.5H23.2734C22.7616 14.9451 22.5001 16.4669 22.5 18V20.25C22.5 20.8467 22.7371 21.419 23.159 21.8409C23.581 22.2629 24.1533 22.5 24.75 22.5H47.25C47.8467 22.5 48.419 22.2629 48.841 21.8409C49.2629 21.419 49.5 20.8467 49.5 20.25V18C49.4999 16.4669 49.2384 14.9451 48.7266 13.5H56.25V60.75Z"
        fill={color}
      />
    </svg>
  );
};
